import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js';


const skioStyles = css`
  .btn {
    background-color: var(--primary);
    border: none;
    color: white;
    border-radius: 5px;
    font-weight: 700;
    cursor: pointer;
    transition: 200ms ease;
    padding: 0.5em 1.5em;
  }

  .btn:hover {
    background-color: var(--primary-hover);
  }

  .btn:disabled {
    opacity: 0.7;
    pointer-events: none;
  }


  .skio-bab {
    --primary: rgb(211, 26, 93);
    --primary-hover: rgb(56, 58, 60);
    --font-primary: "Knockout 27juniorbantamwt", sans-serif;
    --font-secondary: Assistant, sans-serif;
  }

  .skio-bab {
    margin: auto;
    margin-bottom: 4rem;
    width: 90%;
    max-width: 1500px;
    color: #000;
    font-family: var(--font-secondary);
  }

  .skio-bab__title, .skio-bab__subtitle, .skio-bab__description {
    text-align: center;
  }


  .skio-bab__title {
    font-family: var(--font-primary);
    font-size: 4rem;
    line-height: 100%;
  }

  .skio-bab__subtitle {
    max-width: 740px;
    margin: 2rem auto;
    font-weight: 400;
  }


  .skio-bab-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-areas: "products products products products cart cart cart";
    grid-auto-rows: max-content;
    align-items: flex-start;
    gap: 2rem;
  }

  .skio-bab-products {
    grid-area: products;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 2rem;
  }

  .skio-bab-cart {
    grid-area: cart;
    border: 1px solid currentColor;
    width: 100%;
    display: flex;
    flex-direction: column;
    position: sticky;
    top: 1rem;
  }

  .skio-bab-cart__title {
    text-align: center;
    margin: 1rem;
    font-family: var(--font-primary);
    font-size: 3rem;
  }

  .skio-bab-cart__description {
    margin: 0 0 10px 0;
    padding: 0 10px;
    text-align: center;
  }

  .skio-bab-product-card {
    text-align: center;
    line-height: 120%;
    color: #000;
  }

  .skio-bab-product-card__image img {
    display: block;
    max-width: 100%;
    height: auto;
  }

  .skio-bab-product-card__title {
    margin: 1rem 0;
    text-transform: uppercase;
    font-size: 2.5rem;
    line-height: 120%;
    font-family: var(--font-primary);
  }

  .skio-bab-product-card__price {
    margin: 1rem 0;
  }

  .skio-bab-product-card__price s {
    margin: 0 0.5rem;
    font-weight: 400;
  }

  .skio-bab-product-card__atc {
    width: 100%;
  }

  .skio-bab-cart-item {
    display: flex;
    gap: 1rem;
    padding: 1rem 0.5rem;
    line-height: 120%;
    position: relative;
    border-bottom: 1px solid rgba(0,0,0,0.125);
  }

  .skio-bab-cart-item:last-of-type {
    border-bottom: none;
  }

  .skio-bab-cart-item__image {
    width: 120px;
  }

  .skio-bab-cart-item__image img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  .skio-bab-cart-item__info {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    flex-grow: 1;
  }

  .skio-bab-cart-item__title {
    font-weight: 600;
    font-size: 14px;
  }

  .skio-bab-cart__subtitle {
    text-align: center;
    font-weight: 400;
    padding: 2rem 0;
  }

  .skio-bab-cart-item__total {
    margin-top: auto;
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .skio-bab-cart-item__remove {
    display: inline-flex;
    background: none;
    margin-left: auto;
    cursor: pointer;
    // border: 1px solid var(--primary);
    border: none;
    padding: 0.5em;
    border-radius: 5px;
  }

  .skio-bab-cart__footer {
    margin-top: 2rem;
    border-top: 1px solid rgba(0,0,0,0.125);
    padding: 1rem;
    margin-top: auto;
  }

  .skio-bab-cart__subscription {
    margin: 0 0 2rem;
  }



  .skio-bab-cart__subtotal {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    font-size: 18px;
  }

  .skio-bab-cart__info {
    margin: 0;
  }

  .skio-bab-cart__checkout {
    margin-top: 1rem;
    font-size: 16px;
    padding: 1.5rem 2rem;
    display: block;
    text-decoration: none;
    text-align: center;
  }

  .skio-bab-plan-picker__label {
    font-weight: 600;
  }

  .skio-bab-plan-picker__select {
    border: none;
    padding: 1rem;
    width: 100%;
    max-width: 320px;
    border: 1px solid rgba(0,0,0,0.125);
    border-radius: 5px;
  }

  .skio-bab-quantity-picker {
    display: flex;
    gap: 1rem;
    margin: auto;
    justify-content: center;
  }

  .skio-bab-quantity-picker__status {
    line-height: 150%;
  }

  .skio-bab-quantity-picker__btn {
    width: 25px;
    height: 25px;
    padding: 0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }


  @media (max-width: 992px) {
    .skio-bab-grid {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
`

export class SkioBuildABoxComponent extends LitElement {
  static styles = skioStyles;

  static properties = {
    products: { type: Array },
    cart: { type: Array },
    selectedFrequencyIndex: { type: Number },
    isLoading: { type: Boolean }
  };

  constructor() {
    super();
    this.products = [];
    this.cart = [];
    this.selectedFrequencyIndex = 0;
    this.isLoading = false;
    this.dynamicBox = {};
  }

  async connectedCallback() {
    super.connectedCallback();

    document.addEventListener("shopify:section:load", this.requestUpdate)
    this.getBoxId()
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    document.removeEventListener("shopify:section:load", this.requestUpdate)
  }


  get subtotal() {
    return this.cart.reduce((acc, {product, quantity}) => {
      acc += product.variants[0].selling_plan_allocations[0].price_adjustments[0].price * quantity;
      return acc
    }, 0)
  }

  updated(changed){
    console.log('products', this.products);
    console.log('box', this.dynamicBox);
    console.log('selectedFrequencyIndex', this.selectedFrequencyIndex);
  }


  addToCart(product, quantity = 1) {
    this.isLoading = true;
    this.cart = [...this.cart, {
      quantity,
      product
    }];

    setTimeout(() => {
      this.isLoading = false;
    }, 500);
  }

  removeFromCart(productId) {
    this.cart = this.cart.filter(({product}) => product.id !== productId)
  }

  setQuantity(product, quantity) {
    if (quantity <= 0) {
      return
    }

    this.cart = this.cart.map((lineItem) => {
      if (product.id === lineItem.product.id) {
        lineItem.quantity = quantity
      }
      return lineItem
    });
  }

  get sellingPlans(){
    return this.cart[0].product.selling_plan_groups.find(spg => spg.app_id === 'SKIO')?.selling_plans
  }

  get totalItems(){
    return this.cart.reduce((acc, {quantity}) => {
      acc += quantity
      return acc
    }, 0)
  }

  get subtotal() {
    return this.cart.reduce((acc, {product, quantity}) => {
      acc += product.variants[0].price * 0.85 * quantity;
      return acc
    }, 0)
  }

  checkout() {
    let data = {items: []};

    this.cart.forEach(cartItem => {
      const sellingPlanGroups = cartItem.product.selling_plan_groups.find(spg => spg.app_id === 'SKIO');
      const sellingPlanId = sellingPlanGroups?.selling_plans[this.selectedFrequencyIndex].id
      data.items.push({
        id: cartItem.product.variants[0].id,
        quantity: cartItem.quantity,
        selling_plan: sellingPlanId,
        properties: {
          "_dynamicBoxIndex": 0,
          "_dynamicBoxId": this.dynamicBox.boxId
        }
      })
    }, [])

    console.log(data)

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      window.location.href = '/checkout'
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  getBoxId() {
    fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
      method: 'POST',
      body: JSON.stringify({
        'productPlatformId': 7689411690691,
      })
    })
    .then((response) => response.json())
    .then((response) => {
      if(!response.ok) throw new Error('Failed to get box');
      const { DynamicBox } = response;
      this.dynamicBox = DynamicBox;
    })
    .catch((error) => {
      console.error(error);
    })
  }

  quantityPicker(product) {
    const cartItem = this.cart.find(cartItem => product.id === cartItem.product.id);

    return html`
    <div class="skio-bab-quantity-picker">
      <button class="skio-bab-quantity-picker__btn btn" @click="${() => this.setQuantity(product, cartItem.quantity - 1)}" ?disabled=${cartItem.quantity <= 1}>-</button>
      <div class="skio-bab-quantity-picker__status">${cartItem.quantity}</div>
      <button class="skio-bab-quantity-picker__btn btn" @click="${() => this.setQuantity(product, cartItem.quantity + 1)}">+</button>
    </div>
  `
  }

  render() {
    return html`
      <div id="skio-build-a-box" class="skio-bab">
        <h2 class="skio-bab__title">Join the Really Good Boxed Wine Club</h2>
        <p class="skio-bab__description">
          Wine Club Members save 15% of all orders, as well as receive exclusive access to Wine Club only wines, first access to all releases, free tickets to tasting events nationwide, and more! <br>
          Wine Club Memberships require 2 or more boxes per shipment
        </p>
        <h4 class="skio-bab__subtitle">Step 1: Choose the first wines you want to receive with your Membership, this will ship immediately. Don't worry, you can always change your wine or shipment date for future orders.</h4>
        <div class="skio-bab-grid">
          <div class="skio-bab-grid__products skio-bab-products">
            ${
      this.products.map((product) => html`
                <div class="skio-bab-product-card">
                  <a href="/products/${product.handle}" class="skio-bab-product-card__image">
                    <img src=${product.featured_image} alt=${product.title}>
                  </a>
                  <div class="skio-bab-product-card__title">${product.title}</div>
                  <div class="skio-bab-product-card__price">
                    <s>${money(product.price)}</s>
                    ${money(product.variants[0].price * 0.85)}
                  </div>
                  <div class="skio-bab-product-card__actions">
                    ${
        this.cart.some(cartItem => product.id === cartItem.product.id) ? html`
                        ${this.quantityPicker(product)}
                      ` : html`
                        <button class="skio-bab-product-card__atc btn" @click="${ e => this.addToCart(product) }" .disabled=${this.isLoading}>Add</button>
                      `
      }
                  </div>
                </div>
              `)
    }
          </div>
          <div class="skio-bab-grid__cart skio-bab-cart">
            <div class="skio-bab-cart__title">My Wine Club Selection(s)</div>
            <p class="skio-bab-cart__description">Please select 2 or more boxes to join the Wine Club</p>
            <div class="skio-bab-cart__items-grid">
              ${
      !this.cart.length ? html`
                 <h5 class="skio-bab-cart__subtitle">Your cart is empty. Please select 2 or more boxes to join Wine club<h5>
                ` : null
    }
              ${
      this.cart.map(({product, quantity}) => html`
                  <div class="skio-bab-cart__item skio-bab-cart-item">
                    <div class="skio-bab-cart-item__image">
                      <img src=${product.featured_image} alt="">
                    </div>
                    <div class="skio-bab-cart-item__info">
                      <div class="skio-bab-cart-item__title">${product.title}</div>
                      <div class="skio-bab-cart-item__price">${money(product.variants[0].price * 0.85)} x ${quantity}</div>
                      <div class="skio-bab-cart-item__total">
                        <div>
                          <s>${money(product.price * quantity)}</s>
                          ${money(product.variants[0].price * 0.85 * quantity)}
                        </div>
                        <button @click=${() => this.removeFromCart(product.id)} class="skio-bab-cart-item__remove" .disabled=${this.isLoading}>🗑️</button>
                      </div>
                      
                    </div>
                  </div>
                `)
    }
            </div>
            ${
      this.totalItems > 1 ? html`
                <div class="skio-bab-cart__footer">
                  <div class="skio-bab-cart__subscription skio-bab-plan-picker">
                    <div class="skio-bab-plan-picker__label">Step 2. Select how often you want the wine(s) shipped:</div>
                    <select class="skio-bab-plan-picker__select" @change=${ (e) => this.selectedFrequencyIndex = e.target.value }>
                      ${
        this.sellingPlans.map((sp, index) => html`
                          <option value=${index} ?selected=${this.selectedFrequencyIndex === index }>${sp.name.replace('BAB ', '')}</option>
                        `)
      }
                    </select>
                  </div>
                  <div class="skio-bab-cart__subtotal">
                    <span>Subtotal</span>
                    <span>${money(this.subtotal)}</span>
                  </div>
                  <p class="skio-bab-cart__info">Shipping and taxes calculated at checkout.</p>
                  <button type="button" @click=${this.checkout} class="skio-bab-cart__checkout btn">Proceed to checkout</button>
                </div>
              ` : null
    }
          </div>
        </div>
      </div>
    `
  }
}

customElements.define('skio-build-a-box', SkioBuildABoxComponent);


/* 
 Global money formatter
 */
const moneyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: window?.Shopify?.currency?.active || 'USD',
});

/* 
 Formats integer value into money value
 */
const money = (price) => {
  return moneyFormatter.format(price / 100.0)
}

/*
 Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
 */
const getSubscriptionDiscount = (variant, selling_plan) => {
  if (!selling_plan)
    return { percent: '0%', amount: 0 }

  const price_adjustment = selling_plan.price_adjustments[0]
  const discount = { percent: '0%', amount: 0 }
  const price = variant.price;

  if(this.subscriptionDiscountOverride) {
    return {
      percent: this.subscriptionDiscountOverride + '%',
      amount:  Math.round((price * this.subscriptionDiscountOverride) / 100.0)
    }
  }

  switch (price_adjustment.value_type) {
    case 'percentage':
      discount.percent = `${price_adjustment.value}%`
      discount.amount = Math.round(
        (price * price_adjustment.value) / 100.0
      )
      break
    case 'fixed_amount':
      discount.percent = `${Math.round(
        ((price_adjustment.value * 1.0) / price) * 100.0
      )}%`
      discount.amount = price_adjustment.value
      break
    case 'price':
      discount.percent = `${Math.round(
        (((price - price_adjustment.value) * 1.0) /
          price) *
        100.0
      )}%`
      discount.amount = price - price_adjustment.value
      break
  }

  return discount
}